import {
  CONTACTS,
  CONTACTS_CATEGORIES,
  PUBLICATIONS,
  PUBLICATIONS_CATEGORIES,
  SHARE_DOCUMENT,
} from "./const";
import Fetcher from "./fetcher";
import {
  IContactsCategoriesListRes,
  IContactsListRes,
  IPublicationsCategoriesListRes,
  IPublicationsListRes,
  IShareDataArg,
} from "./types";

const API = {
  getPublicationsCategories: async () => {
    const response = await Fetcher.get<IPublicationsCategoriesListRes>(
      PUBLICATIONS_CATEGORIES,
    );
    return response.data; // -> Category[]
  },

  getPublications: async (arg: string) => {
    const response = await Fetcher.get<IPublicationsListRes>(PUBLICATIONS, {
      params: { id: arg },
    });
    return response; // -> Publications[]
  },

  getContactsCategories: async () => {
    const response =
      await Fetcher.get<IContactsCategoriesListRes>(CONTACTS_CATEGORIES);
    return response.data; // -> ContactCategory[]
  },

  getContacts: async (arg: string) => {
    const response = await Fetcher.get<IContactsListRes>(CONTACTS, {
      params: { id: arg },
    });
    return response; // -> Contacts[]
  },

  shareDocument: async (arg: IShareDataArg) => {
    const response = await Fetcher.post<IShareDataArg, unknown>(
      SHARE_DOCUMENT,
      arg,
    );
    console.log("Share document response:", response);
    return response.status === 200;
  },
};

export default API;
